<template>
  <div id="app">
    <!-- 登录页面 -->
    <router-view v-if="$route.path === '/login'"/>

    <!-- 主应用布局 -->
    <div v-else class="app-container">
      <div class="sidebar">
        <div class="sidebar-header">
          <h1><i class="fas fa-shield-alt"></i> AI全球播</h1>
          <p class="subtitle">开启直播2.0时代</p>
        </div>
        <ul class="nav-menu">
          <li class="nav-item">
            <a class="nav-link" :class="{ active: $route.path === '/' }" @click="toUrl('/')">
              <i class="fas fa-home"></i>
              <span>首页数据大屏</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" :class="{ active: $route.path === '/account' }" @click="toUrl('/account')">
              <i class="fas fa-user"></i>
              <span>直播账号管理</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" :class="{ active: $route.path === '/product-explanation' }"
               @click="toUrl('/product-explanation')">
              <i class="fas fa-shopping-bag"></i>
              <span>商品弹窗讲解</span>
            </a>

          </li>
          <li class="nav-item">
            <a class="nav-link" :class="{ active: $route.path === '/field-control' }" @click="toUrl('/field-control')">
              <i class="fas fa-comments"></i>
              <span>直播文字场控</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" :class="{ active: $route.path === '/violation' }" @click="toUrl('/violation')">
              <i class="fas fa-comment-dots"></i>
              <span>直播文字回复</span>
            </a>
          </li>
          <li class="nav-item" v-if="$store.state.userInfo?.select_type!='tiktok'">
            <a class="nav-link" :class="{ active: $route.path === '/sticky' }" @click="toUrl('/sticky')">
              <i class="fas fa-thumb-tack"></i>
              <span>直播置顶贴片</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" :class="{ active: $route.path === '/stats' }" @click="toUrl('/stats')">
              <i class="fas fa-microphone"></i>
              <span>智能语音直播</span>
            </a>

          </li>
          <li class="nav-item">
            <a class="nav-link" :class="{ active: $route.path === '/voice-reply' }" @click="toUrl('/voice-reply')">
              <i class="fas fa-file-alt"></i>
              <span>直播话术管理</span>
            </a>
          </li>

          <li class="nav-item">
            <a class="nav-link" :class="{ active: $route.path === '/audio-playback' }"
               @click="toUrl('/audio-playback')">
              <i class="fas fa-volume-up"></i>
              <span>碎片音频直播</span>
            </a>

          </li>
          <!--        <li class="nav-item">
                    <router-link to="/yellow-cart" class="nav-link" :class="{ active: $route.path === '/yellow-cart' }">
                      <i class="fas fa-shopping-cart"></i>
                      <span>黄车采集</span>
                    </router-link>
                  </li>-->
          <!--        <li class="nav-item">
                    <router-link to="/settings" class="nav-link" :class="{ active: $route.path === '/settings' }">
                      <i class="fas fa-cog"></i>
                      <span>系统设置</span>
                    </router-link>
                  </li>-->
        </ul>
      </div>

      <div class="main-area">
        <div class="header">
          <div class="header-left">
            <div class="ad-banner">

              <div class="ad-content">
                <div class="ad-features">
                  <span class="feature-tag"><i class="fas fa-globe"></i> 全球直播</span>
                  <span class="feature-tag"><i class="fas fa-microphone"></i> 5秒复刻</span>
                  <span class="feature-tag"><i class="fas fa-shield-alt"></i> 独家防封</span>
                  <span class="feature-tag"><i class="fas fa-chart-line"></i> 智能场控</span>
                  <span class="feature-tag"><i class="fas fa-message"></i><span
                      class="logo-badge">AI</span> 智能话术</span>
                  <span class="feature-tag"><i class="fas fa-robot"></i> AI替你播</span>
                  <button class="ad-btn" @click="goUrl('https://icnk81st2d4i.feishu.cn/wiki/YrgSw3kLoi48BKk0PWPcFDItn2f?from=from_copylink')">了解更多</button>

                </div>
              </div>

            </div>
          </div>
          <div class="header-right">
            <div class="user-profile" @click="showUserMenu = !showUserMenu">
              <i class="fas fa-shield-alt"></i>
              <div class="user-info">
                <div class="user-name vip-text">{{ $store.state.userInfo?.nickname }}</div>
              </div>
              <i class="fas fa-chevron-down user-arrow"></i>
            </div>
            <div class="window-controls">
              <button class="window-btn minimize" @click="eSend('window','minus')">
                <i class="fas fa-window-minimize"></i>
              </button>
              <button class="window-btn close" @click="eSend('window','close')">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="main-content">
          <keep-alive include="AudioPlayback">
          <router-view></router-view>
          </keep-alive>
        </div>

        <div class="footer">
          <div class="footer-left">
            <div class="footer-status">
              <div class="status-indicator online"></div>
              <span>系统在线</span>
            </div>
            <span class="footer-time">{{ currentTime }}</span>
          </div>
          <p class="footer-center">&copy; 2026 AI全球播 - 智能直播中控系统</p>
          <div class="footer-right">
            <span>到期时间：{{ $store.state.userInfo?.vip_time_text }}</span>
          </div>
        </div>
      </div>

      <!-- 修改密码弹窗 -->
      <div v-if="showChangePassword" class="modal-overlay" @click.self="showChangePassword = false">
        <div class="modal-container">
          <div class="modal-header">
            <h3><i class="fas fa-key"></i> 修改密码</h3>
            <button class="modal-close" @click="showChangePassword = false">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>原密码</label>
              <input type="password" v-model="oldPassword" class="form-input" placeholder="请输入原密码">
            </div>
            <div class="form-group">
              <label>新密码</label>
              <input type="password" v-model="newPassword" class="form-input" placeholder="请输入新密码">
            </div>
            <div class="form-group">
              <label>确认密码</label>
              <input type="password" v-model="confirmPassword" class="form-input" placeholder="请再次输入新密码">
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="showChangePassword = false">取消</button>
            <button class="btn btn-primary" @click="changePassword">确认修改</button>
          </div>
        </div>
      </div>


      <!-- 充值卡密弹窗 -->
      <div v-if="showRecharge" class="modal-overlay" @click.self="showRecharge = false">
        <div class="modal-container">
          <div class="modal-header">
            <h3><i class="fas fa-credit-card"></i> 充值卡密</h3>
            <button class="modal-close" @click="showRecharge = false">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>卡密</label>
              <input type="text" v-model="rechargeCode" class="form-input" placeholder="请输入充值卡密">
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="showRecharge = false">取消</button>
            <button class="btn btn-primary" @click="recharge">确认充值</button>
          </div>
        </div>
      </div>

      <!-- 用户菜单遮罩层（点击外部关闭菜单） -->
      <div v-if="showUserMenu" class="user-menu-overlay" @click="showUserMenu = false"></div>
      <!-- 用户菜单（放在页面根部以避免被遮挡） -->
      <div v-if="showUserMenu" class="user-menu">
        <div class="menu-item" @click="showChangePassword = true">
          <i class="fas fa-key"></i>
          <span>修改密码</span>
        </div>

        <div class="menu-item" @click="showRecharge = true">
          <i class="fas fa-credit-card"></i>
          <span>充值卡密</span>
        </div>
        <div class="menu-divider"></div>
        <div class="menu-item logout" @click="logout">
          <i class="fas fa-sign-out-alt"></i>
          <span>退出账号</span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

import http from "@/utils/http";
import store from "@/store";
import {eSend} from "@/utils/function";

export default {
  name: 'App',
  computed: {
    store() {
      return store
    },
    apiKey() {
      return this.$store.state.apiKey;
    }
  },
  components: {},
  data() {
    return {
      welcomeDeep: null,//等待时间
      explainIndex: 1,//当前讲解
      explainTimer: null,//讲解定时器
      textIndex: 1,//文字场控
      textTimer: null,//文字场控定时器
      userInfo: null,
      currentTime: '',
      showUserMenu: false,
      showChangePassword: false,
      showRecharge: false,
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      rechargeCode: '',
      isAIEnabled: false,

    }
  },
  async mounted() {

    eSend("check", "")
    this.getAppConfig();
    window.dialog = this.$dialog;
    this.$store.commit("setAudios", {
      anchorAudio: new Audio(),
      keywordAudio: new Audio(),
      timingAudio: new Audio(),
      welcomeAudio: new Audio(),
    })

    window.app = this;
    this.getUser();
    if (!window.userStatusTimer) {
      window.userStatusTimer = setInterval(async () => {
        await this.heartbeat();
        this.getUser();
      }, 5000)
    }
    this.updateTime()
    setInterval(this.updateTime, 1000)
    //this.autoInit();

    if (!this.apiKey) {
      const res = await http.get("api/ai/getKey");
      this.$store.commit("setApiKey", res.data);
    }


    this.setAudioConfig();

    const res = await http.get("api/ai/getKey");
    if (res.code == 200) {
      this.$store.commit("setApiKey", res.data);
    }


  },
  methods: {

    setTTSStatus(status) {
      this.$store.commit("setTtsStatus", status ? true : false);
    },

    eSend,
    async setAudioConfig() {

      const modules = await this.Db("音色控制配置").find() || {
        anchor: {
          volume: 100,
          speed: 50,
          enabled: false,
          minInterval: 0,
          maxInterval: 0
        },
        keyword: {
          volume: 100,
          speed: 50,
          enabled: false,
          minInterval: 0,
          maxInterval: 0,
        },
        timing: {
          volume: 100,
          speed: 50,
          pitch: 50,
          enabled: false,
          minInterval: 60,
          maxInterval: 180
        },
        welcome: {
          volume: 100,
          speed: 50,
          pitch: 50,
          noise: 0,
          enabled: false,
          minInterval: 60,
          maxInterval: 180
        }
      }
      this.$store.commit("setModules", modules);


      const data = await this.Db("音色配置").find();
      if (data) {
        this.$store.commit("setVoicesConfig", data);
      }


    },


    async getAppConfig() {

      const res = await http.get("api/config/index");
      if (res.code == 200) {
        this.$store.commit("setAppids", res.data.talk);
      }

    },


    autoInit() {
      /*
            this.autoExplain();
            this.autoText();
            this.autoControl();*/
    },
    outUser() {
      const token = localStorage.getItem("token");

      localStorage.removeItem("token");
      if (this.$route.path != '/login') {
        this.$dialog.tips({
          type: "error",
          message: token ? "你的账号已在其它设备上登录" : '请先登录后再使用'
        })
        this.$router.push("/login")

      }

    },
    goUrl(url){

      window.open(url)
    },
    toUrl(path) {
      if (this.$route.path != path) {
        this.$router.push(path)
      }
    },
    async Eyy(type, data = {}) {

      console.log(JSON.stringify({
        type,
        data
      }));
    },
    async heartbeat() {

      const res = await http.get("api/user/heartbeat");
      if (res.code == 0) {

        this.$dialog.tips({
          type: "error",
          message: res.msg
        })
      }

    },

    async getUser() {
      const res = await http.get("api/user/info")

      this.$store.commit("setUserInfo", res.data);

    },

    updateTime() {
      const now = new Date()
      this.currentTime = now.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    },
    async changePassword() {
      if (!this.oldPassword) {
        this.$dialog.tips({
          message: "请输入原密码",
          type: "error",
        })
        return
      }
      if (!this.newPassword) {
        this.$dialog.tips({
          message: "请输入新密码",
          type: "error",
        })
        return
      }
      if (this.newPassword !== this.confirmPassword) {
        this.$dialog.tips({
          message: "两次输入的密码不一致",
          type: "error",
        })
        return
      }

      const res = await http.post("api/user/editPass", {
        pwd: this.newPassword,
        oldpwd: this.oldPassword,
        confirmPwd: this.confirmPassword,

      });
      if (res.code == 200) {
        this.$dialog.tips({
          message: res.msg,
          type: "success",
        })
        this.showChangePassword = false
        this.oldPassword = ''
        this.newPassword = ''
        this.confirmPassword = ''
        return;
      }

      this.$dialog.tips({
        message: res.msg,
        type: "error",
      })
    },
    async recharge() {
      if (!this.rechargeCode) {
        this.$dialog.tips({
          message: "请输入充值卡密",
          type: "error"
        })
        return
      }
      const res = await http.post("api/user/recharge", {cardKey: this.rechargeCode});

      if (res.code == 200) {
        this.$dialog.tips({
          message: res.msg,
          type: "success"
        })
        this.showRecharge = false
        this.rechargeCode = ''
        return;
      }
      this.$dialog.tips({
        message: res.msg,
        type: "error"
      })


    },
    async logout() {

      const confirm = await this.$dialog.confirm({
        title: "温馨提示",
        message: "确定要退出账号吗",
        okText: "确认",
        cancelText: "取消"
      }).catch(() => false);

      if (confirm !== false) {
        localStorage.removeItem("token");
        this.$router.push("/login")
        this.showUserMenu = false
      }


    }
  }
}
</script>

<style>
input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background: linear-gradient(135deg, #0a0a0a 0%, #121218 30%, #0a0a0a 70%, #121218 100%);
  min-height: 100vh;
  color: #e8e8e8;
  overflow-x: hidden;
  position: relative;
}

body::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at 10% 20%, rgba(139, 92, 246, 0.08) 0%, transparent 25%),
  radial-gradient(circle at 90% 80%, rgba(34, 211, 238, 0.06) 0%, transparent 25%),
  radial-gradient(circle at 50% 50%, rgba(168, 85, 247, 0.04) 0%, transparent 35%),
  radial-gradient(circle at 25% 75%, rgba(59, 130, 246, 0.05) 0%, transparent 20%),
  radial-gradient(circle at 75% 25%, rgba(16, 185, 129, 0.05) 0%, transparent 20%);
  pointer-events: none;
  z-index: -1;
}

.app-container {
  display: flex;
  min-height: 100vh;
  padding: 20px 0;
  background: linear-gradient(180deg, #1a1a1a 0%, #2d2d2d 50%, #1a1a1a 100%);
}

.sidebar {
  margin-left: 20px;
  width: 270px;
  background: linear-gradient(180deg, #252525 0%, #1f1f1f 50%, #252525 100%);
  backdrop-filter: blur(20px);
  box-shadow: 5px 0 30px rgba(0, 0, 0, 0.4),
  inset 0 1px 0 rgba(255, 255, 255, 0.03);
  padding: 30px 0;
  position: relative;
  overflow: hidden;
  border-right: 1px solid rgba(60, 60, 60, 0.5);
  border-radius: 20px;
}


.sidebar::after {
  content: '';
  position: absolute;
  top: -50%;
  right: -20%;
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, rgba(80, 80, 80, 0.1) 0%, transparent 70%);
  border-radius: 50%;
}

.sidebar-header {
  padding: 0 25px 25px;
  border-bottom: 1px solid rgba(60, 60, 60, 0.5);
  margin-bottom: 25px;
  position: relative;
}

.sidebar-header h1 {
  font-size: 26px;
  font-weight: 800;
  background: linear-gradient(90deg, #ffffff 0%, #c4b5fd 30%, #a5f3fc 50%, #bbf7d0 70%, #ffffff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 0;
  letter-spacing: 2px;
}

.sidebar-header h1 i {
  color: #a78bfa;
  font-size: 26px;
  text-shadow: 0 0 25px rgba(167, 139, 250, 0.5);
}

.sidebar-header .subtitle {
  font-size: 12px;
  color: rgba(180, 180, 180, 0.7);
  margin: 12px 0 0 0;
  font-weight: 500;
  padding-left: 45px;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.nav-menu {
  list-style: none;
  position: relative;
}

.nav-item {
  margin-bottom: 8px;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 16px 25px;
  color: rgba(170, 170, 170, 0.9);
  text-decoration: none;
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  border-left: 3px solid transparent;
  position: relative;
  overflow: hidden;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.nav-link::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, rgba(139, 92, 246, 0.15) 0%, rgba(34, 211, 238, 0.1) 50%, rgba(16, 185, 129, 0.1) 100%);
  transition: left 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.nav-link:hover::before {
  left: 0;
}

.nav-link:hover {
  background: rgba(139, 92, 246, 0.12);
  color: #f0f0f0;
  border-left-color: #a78bfa;
  transform: translateX(4px);
}

.nav-link.active {
  background: linear-gradient(90deg, rgba(139, 92, 246, 0.2) 0%, rgba(34, 211, 238, 0.1) 100%);
  color: #f8f8f8;
  border-left-color: #c4b5fd;
  font-weight: 600;
  box-shadow: inset 0 0 30px rgba(139, 92, 246, 0.15),
  0 0 25px rgba(139, 92, 246, 0.1);
}

.nav-link i {
  font-size: 18px;
  width: 26px;
  text-align: center;
  transition: all 0.35s ease;
  color: rgba(150, 150, 150, 0.8);
}

.nav-link:hover i {
  color: #c4b5fd;
  text-shadow: 0 0 20px rgba(196, 181, 253, 0.4);
}

.nav-link.active i {
  color: #a78bfa;
  text-shadow: 0 0 25px rgba(167, 139, 250, 0.5);
}

.main-area {
  flex: 1;
  padding: 3px 20px 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  background: transparent;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  padding: 20px 30px;
  background: linear-gradient(135deg, rgba(35, 35, 35, 0.95) 0%, rgba(25, 25, 25, 0.95) 100%);
  backdrop-filter: blur(15px);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(60, 60, 60, 0.5);
}


.ad-banner {
  display: flex;
  align-items: center;
  gap: 25px;
  padding: 10px 30px;
  background: linear-gradient(135deg, rgba(30, 30, 30, 0.95) 0%, rgba(40, 40, 45, 0.95) 100%);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(30px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4),
  inset 0 1px 0 rgba(255, 255, 255, 0.05),
  inset 0 -1px 0 rgba(0, 0, 0, 0.3);

}

@keyframes subtleFloat {
  0%, 100% {
    transform: translateX(-8px) translateY(-4px);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.05),
    inset 0 -1px 0 rgba(0, 0, 0, 0.3);
  }
  50% {
    transform: translateX(-8px) translateY(-8px);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5),
    inset 0 1px 0 rgba(255, 255, 255, 0.08),
    inset 0 -1px 0 rgba(0, 0, 0, 0.3);
  }
}

.ad-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(60, 60, 60, 0.9) 0%, rgba(80, 80, 80, 0.9) 100%);
  border-radius: 12px;
  color: rgba(180, 180, 180, 0.9);
  font-size: 18px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.ad-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
}

.ad-title {
  font-size: 15px;
  font-weight: 600;
  color: #a78bfa;
  margin: 0;
  text-shadow: 0 0 10px rgba(167, 139, 250, 0.5);
}

.ad-desc {
  font-size: 12px;
  color: rgba(170, 170, 170, 0.8);
  margin: 0;
}

.ad-tagline {
  font-size: 11px;
  color: rgba(139, 92, 246, 0.9);
  margin: 0;
  font-weight: 500;
}

.ad-features {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.feature-tag {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 5px 12px;
  background: rgba(80, 80, 80, 0.5);
  border-radius: 12px;
  font-size: 11px;
  color: rgba(170, 170, 170, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.feature-tag:hover {
  background: rgba(100, 100, 100, 0.6);
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
}

.logo-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  background: linear-gradient(135deg, #667eea 0%, #f093fb 100%);
  border-radius: 3px;
  font-size: 8px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 4px;
  box-shadow: 0 1px 3px rgba(102, 126, 234, 0.4);
}

.ad-highlight {
  font-size: 12px;
  color: rgba(167, 139, 250, 0.9);
  margin: 8px 0 0;
  font-weight: 500;
  font-style: italic;
}

.feature-tag i {
  font-size: 10px;
  color: rgba(167, 139, 250, 0.8);
}

.ad-actions {
  display: flex;
  gap: 10px;
}

.ad-btn {
  padding: 8px 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
  border: none;
  border-radius: 8px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.ad-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.5);
  background: linear-gradient(135deg, #7c8eea 0%, #865ba2 50%, #f5a3fb 100%);
}

.ad-btn-secondary {
  padding: 8px 16px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: rgba(150, 150, 150, 0.9);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.ad-btn-secondary:hover {
  background: rgba(100, 100, 100, 0.3);
  border-color: rgba(255, 255, 255, 0.3);
}


.header h1 {
  font-size: 28px;
  font-weight: 700;
  color: #ccc;
  display: flex;
  align-items: center;
  gap: 12px;
}

.header h1 i {
  color: #888;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-left: auto;
}

.status-bar {
  display: flex;
  gap: 25px;
  align-items: center;
}

.user-profile {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 20px;
  background: linear-gradient(135deg, rgba(60, 60, 60, 0.7) 0%, rgba(80, 80, 85, 0.7) 100%);
  border-radius: 30px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(10px);
}

.user-profile:hover {
  background: linear-gradient(135deg, rgba(80, 80, 80, 0.8) 0%, rgba(100, 100, 105, 0.8) 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.4),
  inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-weight: 700;
  font-size: 15px;
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4),
  inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.user-info {
  display: flex;
  flex-direction: column;
}

.user-name {
  font-size: 15px;
  font-weight: 600;
  color: #e0e0e0;
}

.user-name.vip-text {
  background: linear-gradient(135deg, #c4b5fd 0%, #a5f3fc 25%, #bbf7d0 50%, #a5f3fc 75%, #c4b5fd 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  background-size: 300% auto;
  animation: gradient 4s ease infinite;
}

@keyframes gradient {
  0% {
    background-position: 0% center;
  }
  50% {
    background-position: 100% center;
  }
  100% {
    background-position: 0% center;
  }
}

.user-role {
  font-size: 12px;
  color: #999;
}

.window-controls {
  display: flex;
  gap: 8px;
  align-items: center;
}

.window-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
}

.window-btn.minimize {
  background: rgba(139, 92, 246, 0.2);
  color: #a78bfa;
  border: 1px solid rgba(139, 92, 246, 0.3);
}

.window-btn.close {
  background: rgba(239, 68, 68, 0.2);
  color: #f87171;
  border: 1px solid rgba(239, 68, 68, 0.3);
}

.window-btn:hover {
  transform: translateY(-2px);
}

.window-btn.minimize:hover {
  background: rgba(139, 92, 246, 0.3);
  box-shadow: 0 4px 15px rgba(139, 92, 246, 0.3);
}

.window-btn.close:hover {
  background: rgba(239, 68, 68, 0.3);
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3);
}

.status-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 18px;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.15) 0%, rgba(34, 211, 238, 0.1) 100%);
  border-radius: 25px;
  border: 1px solid rgba(167, 139, 250, 0.3);
  transition: all 0.3s ease;
}

.status-item:hover {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.2) 0%, rgba(34, 211, 238, 0.15) 100%);
  transform: translateY(-2px);
}

.status-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  animation: pulse 2.5s infinite;
}

.status-indicator.online {
  background: linear-gradient(135deg, #10b981 0%, #34d399 100%);
  box-shadow: 0 0 15px rgba(16, 185, 129, 0.6);
}

.status-indicator.warning {
  background: linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%);
  box-shadow: 0 0 15px rgba(245, 158, 11, 0.6);
}

.status-indicator.error {
  background: linear-gradient(135deg, #ef4444 0%, #f87171 100%);
  box-shadow: 0 0 15px rgba(239, 68, 68, 0.6);
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  70% {
    transform: scale(1.15);
  }
  100% {
    transform: scale(1);
  }
}

.status-item span {
  color: #e8e8e8;
  font-size: 13px;
  font-weight: 500;
}

.main-content {
  flex: 1;
}

.footer {
  margin-top: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  background: linear-gradient(135deg, rgba(35, 35, 35, 0.95) 0%, rgba(25, 25, 25, 0.95) 100%);
  backdrop-filter: blur(15px);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(60, 60, 60, 0.5);
  font-size: 13px;
  color: #888;
  position: relative;
}

.footer-left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.footer-center {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.footer-right {
  color: #888;
  font-size: 13px;
}

.footer-status {
  display: flex;
  align-items: center;
  gap: 8px;
}

.footer-status .status-indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.footer-status span {
  color: #888;
  font-size: 13px;
}

.footer-time {
  color: #888;
  font-size: 13px;
}

.footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, #666 0%, #888 50%, #666 100%);
  border-radius: 2px;
}

::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(40, 40, 40, 0.8);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #555 0%, #777 100%);
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #666 0%, #888 100%);
}

.user-arrow {
  font-size: 12px;
  color: rgba(170, 170, 170, 0.7);
  transition: transform 0.3s ease;
}

.user-profile:hover .user-arrow {
  transform: rotate(180deg);
}

.user-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  z-index: 99998;
}

.user-menu {
  position: fixed;
  top: 100px;
  right: 50px;
  width: 180px;
  background: rgba(35, 35, 35, 0.98);
  border-radius: 12px;
  border: 1px solid rgba(170, 170, 170, 0.2);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  z-index: 99999;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  color: rgba(170, 170, 170, 0.9);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.menu-item:hover {
  background: rgba(170, 170, 170, 0.1);
  color: #f0f0f0;
}

.menu-item i {
  width: 18px;
  text-align: center;
  color: rgba(170, 170, 170, 0.7);
}

.menu-item:hover i {
  color: #f0f0f0;
}

.menu-item.logout {
  color: #f87171;
}

.menu-item.logout:hover {
  background: rgba(239, 68, 68, 0.15);
  color: #f87171;
}

.menu-divider {
  height: 1px;
  background: rgba(170, 170, 170, 0.15);
  margin: 8px 0;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.modal-container {
  width: 90%;
  max-width: 450px;
  background: rgba(35, 35, 35, 0.98);
  border-radius: 16px;
  border: 1px solid rgba(170, 170, 170, 0.2);
  overflow: hidden;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  background: rgba(170, 170, 170, 0.1);
}

.modal-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: rgba(170, 170, 170, 0.9);
}

.modal-close {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: rgba(170, 170, 170, 0.1);
  color: rgba(170, 170, 170, 0.7);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.modal-close:hover {
  background: rgba(170, 170, 170, 0.2);
  color: #f0f0f0;
}

.modal-body {
  padding: 24px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(170, 170, 170, 0.9);
}

.form-input {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid rgba(170, 170, 170, 0.2);
  border-radius: 10px;
  background: rgba(30, 30, 30, 0.9);
  color: rgba(170, 170, 170, 0.9);
  font-size: 14px;
  box-sizing: border-box;
}

.form-input::placeholder {
  color: #666;
}

.verify-code {
  display: flex;
  gap: 10px;
}

.verify-code .form-input {
  flex: 1;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  background: rgba(30, 30, 30, 0.9);
}

.btn {
  padding: 10px 24px;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary {
  background: rgba(139, 92, 246, 0.2);
  color: #c4b5fd;
  border: 1px solid rgba(139, 92, 246, 0.3);
}

.btn-primary:hover {
  background: rgba(139, 92, 246, 0.3);
}

.btn-secondary {
  background: rgba(170, 170, 170, 0.1);
  color: rgba(170, 170, 170, 0.9);
  border: 1px solid rgba(170, 170, 170, 0.2);
}

.btn-secondary:hover {
  background: rgba(170, 170, 170, 0.2);
}

.btn-sm {
  padding: 8px 16px;
  font-size: 13px;
}

@media (max-width: 768px) {
  .app-container {
    flex-direction: column;
  }

  .sidebar {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid rgba(108, 99, 255, 0.2);
  }

  .main-area {
    padding: 15px;
  }

  .header {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
    padding: 15px 20px;
  }

  .status-bar {
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
  }

  .status-item {
    flex: 1;
    min-width: 120px;
  }
}
</style>
